import NumberFormat, { NumberFormatProps } from 'react-number-format';

import { TextField, TextFieldProps } from '@mui/material';

export type DateNumberFormatProps = Omit<
  NumberFormatProps<TextFieldProps>,
  'allowEmptyFormatting' | 'allowLeadingZeros' | 'allowNegative' | 'customInput' | 'type'
>;

/**
 * Formatted number input for Date fields
 */
export const DateNumberFormat = (props: DateNumberFormatProps) => {
  return (
    <NumberFormat
      {...props}
      allowEmptyFormatting
      allowLeadingZeros
      allowNegative={false}
      customInput={TextField}
      type="tel"
    />
  );
};
